import { render, staticRenderFns } from "./FullPeriodIoInfoMob.vue?vue&type=template&id=55d4a7fa&scoped=true&"
import script from "./FullPeriodIoInfoMob.vue?vue&type=script&lang=js&"
export * from "./FullPeriodIoInfoMob.vue?vue&type=script&lang=js&"
import style0 from "./FullPeriodIoInfoMob.vue?vue&type=style&index=0&id=55d4a7fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4a7fa",
  null
  
)

export default component.exports